import React, { Component, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import Order from './index';



class OrderContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            alumnoid: 0,
            nombrealumno: '',
            gradoalumno: '',
            nivelalumno: 0,
            grupoalumno: '',
            correo2:''
        };
    }

    componentDidMount() {
        this.populateDetalleAlumno(this.props.match.params.id);
        this.setState({ alumnoid: this.props.match.params.id });
    }//end component

    render() {
        const { alumnoid, nombrealumno, gradoalumno, nivelalumno, grupoalumno, correo2 } = this.state;
        
        //console.log("Por fin alumno id-->"+alumnoid);
        //console.log("container---->correo2 " + correo2);
        return (
            <>
                <br/>
                <Order  {...{
                    alumnoid,
                    nombrealumno,
                    gradoalumno,
                    nivelalumno,
                    grupoalumno,
                    correo2
                }}/>
            </>
        );
    }


    async populateDetalleAlumno(id) {
        const response      = await fetch('/api/Alumno/ObtieneAlumnoPorId?id=' + id);
        const detalleAlumno = await response.json();


        detalleAlumno.map(detalleAlumno =>{

            //console.log("----> " + detalleAlumno.correotutor);

            this.setState({ nombrealumno: (detalleAlumno.nombres + " " + detalleAlumno.apellidopaterno + " " + detalleAlumno.apellidomaterno) });
            this.setState({ gradoalumno: (detalleAlumno.nivel) });
            this.setState({ nivelalumno: (detalleAlumno.nivel2) });
            this.setState({ grupoalumno: (detalleAlumno.grupo) });
            this.setState({ correo2: (detalleAlumno.correotutor) });

            

        });

    }//end method

}
export default connect()(OrderContainer);
